import '../assets/styles/Card.css';

export default function Card({ texto, foto, nome }) {
    return (
        <div className="card">
            <div className="card-text">
                <p>{texto}</p>
            </div>
            <div className="card-foto">
                <img src={foto} alt={nome} />
                <h4>{nome}</h4>
            </div>
        </div>
    );
}